import React from 'react'
import { ArticleModel } from '@/types/api'

type Props = {
  article: ArticleModel
  url: string
}

const ProductJsonLd = ({ article, url }: Props) => {
  const imageUrl = article.imageId
    ? `${process.env.NEXT_PUBLIC_API}/images/${article.imageId}`
    : undefined

  const availability =
    article.quantityAvailable > 0 || article.quantityExternal > 0
      ? 'https://schema.org/InStock'
      : 'https://schema.org/OutOfStock'

  const offer: Record<string, unknown> = {
    '@type': 'Offer',
    url,
    priceCurrency: 'SEK',
    price: article.price,
    availability,
    seller: {
      '@type': 'Organization',
      name: 'StatusFalgar',
    },
  }

  if (article.regularPrice && article.regularPrice !== article.price) {
    offer.priceValidUntil = undefined
    offer.highPrice = article.regularPrice
  }

  const jsonLd: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `${article.brandName} ${article.articleText}`,
    description: article.articleDetails?.description || article.articleText,
    sku: article.id.toString(),
    brand: {
      '@type': 'Brand',
      name: article.brandName,
    },
    offers: offer,
  }

  if (imageUrl) {
    jsonLd.image = imageUrl
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  )
}

export default ProductJsonLd
